/**
 * Utility to access target object value by token
 * @param target
 * @param path
 * @example
 * const obj = {a:{b:{c:10}}}
 * const value = getInByToken('a.b.c') => 10
 */
export const getInByToken = <T>(target: T, path: string) => {
  try {
    return path.split('.').reduce((prev, current) => prev[current], target);
  } catch (e) {
    if (e instanceof TypeError) {
      return undefined;
    } else {
      throw e;
    }
  }
};
